var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',_vm._l((_vm.staticRoots),function(staticRoot){return _c('li',{key:staticRoot},[_c('span',{staticClass:"custom-code"},[_vm._v(_vm._s(staticRoot))])])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }